import { I18nType } from '@/types/i18n'

export const getLocaleStyleKey = (locale?: string) => {
  if (!locale || locale === 'zh-CN') {
    return 'zh-CN'
  }

  if (locale === 'en-US') {
    return 'en'
  }

  if (locale === 'ja-JP') {
    return 'ja'
  }

  if (locale === 'th-TH') {
    return 'th'
  }

  // 新增语言（仅 merchant 页面使用）
  if (locale === 'zh-TW') {
    return 'zh-TW'
  }

  if (locale === 'ko-KR') {
    return 'ko'
  }

  if (locale === 'vi-VN') {
    return 'vi'
  }

  return locale
}

export const getLocaleStyleClass = (locale: string | undefined, style: string) => {
  return `${getLocaleStyleKey(locale)}-${style}`
}

export const createAgentI18n = (i18n?: I18nType) => {
  if (!i18n) {
    return (key: string, defaultValue?: string) => defaultValue || key
  }

  return (key: string, defaultValue?: string) => {
    return (
      i18n.t(key, { ns: 'agent_website', defaultValue: defaultValue || key }) ||
      defaultValue ||
      key
    )
  }
}

export const createMerchantI18n = (i18n?: I18nType) => {
  if (!i18n) {
    return (key: string, defaultValue?: string) => defaultValue || key
  }

  return (key: string, defaultValue?: string) => {
    return (
      i18n.t(key, { ns: 'merchant_website', defaultValue: defaultValue || key }) ||
      defaultValue ||
      key
    )
  }
}

export type AgentI18n = ReturnType<typeof createAgentI18n>
export type MerchantI18n = ReturnType<typeof createMerchantI18n>
